export default "__VITE_ASSET__c5d40aa9__"